import type { SignInController } from '../SignInController';
import type { SignInPhoneStepController } from './SignInPhoneStepController';
import { createCaptcha } from '~/shared/helpers/captcha';
import { unformatPhone } from '~/shared/helpers/formatPhone';
import { useAuthSDK } from '~/features/auth-sdk';
import { snackBarManager } from '~/features/ui-kit';

const captchaId = 'yandex-captcha-phone';

export function useSignInPhoneStep(
  signInController: SignInController,
  phoneStepController: SignInPhoneStepController
) {
  const isPhoneStep = computed(() => signInController.isPhoneStep);
  const phoneStepForm = phoneStepController.form;
  const isLoading = ref(false);
  const formData = phoneStepForm.formData;
  const isFormValid = computed(() => {
    return phoneStepForm.validate()
  });

  const goToPhoneStep = signInController.goToPhoneStep.bind(signInController);
  const resetForm = phoneStepForm.reset.bind(phoneStepForm);

  const { sendOtp, updateSendedOtpData } = useAuthSDK();

  async function handleSubmit() {
    try {
      isLoading.value = true;
      await sendOtp(unformatPhone(formData.phone.value || ''), formData.captcha.value || '');
      signInController.goToCodeStep();
      updateSendedOtpData();
    } catch (error) {
      handleError(error);
    } finally {
      isLoading.value = false;
    }
  }

  function renderCaptcha() {
    nextTick(() => {
      createCaptcha(captchaId, (token: string) => {
        formData.captcha.value = token;
      });
    });
  }

  function handleError(error: any) {
    const errorCode = error.response?.status;
    const errorTextCode = error.data.code;

    if (errorTextCode === 'userIsBlocked') {
      signInController.goToBlockedStep();
      return;
    }
    
    let errorMessage;

    switch (errorCode) {
      case 422:
        errorMessage = 'Ещё действует прошлый код. Можете запросить новый через несколько минут';
        break;
      default:
        errorMessage = 'Код не отправился. Попробуйте еще раз или запросите код позже';
    }

    if (errorTextCode === 'otpTooManyRequests') {
      errorMessage = 'Вы запросили код слишком много раз. Попробуйте снова через 1-3 часа.';
    }

    snackBarManager.showSnackBar({
      type: 'error',
      message: errorMessage,
      dismissible: true,
      duration: 5000,
    });

    renderCaptcha();
    resetForm();
    console.error(error);
  }

  return {
    isPhoneStep,
    goToPhoneStep,
    phoneStepForm,
    isLoading,
    isFormValid,
    formData,
    handleSubmit,
    renderCaptcha,
  };
}
